var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgJumpingWomanIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 131,
    height: 154,
    viewBox: "0 0 131 154",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_14602",
    "data-name": "Group 14602",
    transform: "translate(-1.859)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2067",
    "data-name": "Path 2067",
    d: "M65.5,131.252A65.569,65.569,0,0,1,0,65.8C0,29.626,29.492,0,65.5,0S131,29.626,131,65.8A65.569,65.569,0,0,1,65.5,131.252Z",
    transform: "translate(1.859 3.239)",
    fill: "#bce8fe"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_3667",
    "data-name": "Group 3667",
    transform: "translate(37.168)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1409",
    "data-name": "Path 1409",
    d: "M2.117,6.764,0,4.695S3.81.289,6.742.017s4.827,3.358,4.827,3.358L9.035,7.367Z",
    transform: "matrix(0.602, 0.799, -0.799, 0.602, 43.34, 22.521)",
    fill: "#6639b7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2072",
    "data-name": "Path 2072",
    d: "M2.115.6,0,2.67a44.051,44.051,0,0,0,6.73,1.376,15.1,15.1,0,0,0,3.74.088L9.033,0,5.4.314Z",
    transform: "matrix(-0.602, 0.799, -0.799, -0.602, 12.65, 24.43)",
    fill: "#6639b7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1421",
    "data-name": "Path 1421",
    d: "M5.391,16.989l-1.334.069L0,1.324s4.365,1.108,6.245.006A15.143,15.143,0,0,1,11.576,0L10.3,12.542Z",
    transform: "matrix(0.602, 0.799, -0.799, 0.602, 40.634, 24.542)",
    fill: "#6639b7"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_754",
    "data-name": "Group 754",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2040",
    "data-name": "Path 2040",
    d: "M765.425,524.7s1.68-2.657,4.2-.239,4.32,10.46,4.32,10.46.621,4.2-.962,5.03a1.533,1.533,0,0,1-1.319-.221s-3.83-5.411-4.921-5.651-2.281-3.248-2.281-3.248Z",
    transform: "translate(-717.934 -427.412)",
    fill: "#e9e9e9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2074",
    "data-name": "Path 2074",
    d: "M765.4,524.7s1.68-2.657,4.2-.239,4.319,10.46,4.319,10.46.961,6.5-2.28,4.81c0,0-3.831-5.411-4.921-5.651s-2.281-3.248-2.281-3.248Z",
    transform: "translate(-719.42 -427.412)",
    fill: "#fdfdfd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2041",
    "data-name": "Path 2041",
    d: "M835.947,548.35s2.281-1.084,3-.239,3.121,9.259,3.121,9.259.719,5.533-1.68,5.29-6.6-8.9-6.6-8.9Z",
    transform: "translate(-806.456 -444.566)",
    fill: "#ececec"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2075",
    "data-name": "Path 2075",
    d: "M835.947,548.35s2.281-1.084,3-.239,3.121,9.259,3.121,9.259.719,5.533-1.68,5.29-6.6-8.9-6.6-8.9Z",
    transform: "translate(-807.464 -444.566)",
    fill: "#fdfdfd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2043",
    "data-name": "Path 2043",
    d: "M866.295,459.329l-5.159,8.057s.359,1.8,3.48,1.444l10.681,6.734s.928,8.2-2.039,7.454c-.48-.121-3.83-3.608-6.241-3.365l-14.164-5.533s-3.359-1.925-1.559-8.3,7.753-21.144,7.753-21.144l9.408,5.273Z",
    transform: "translate(-844.725 -371.898)",
    fill: "#6639b7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2044",
    "data-name": "Path 2044",
    d: "M866.295,459.329l-5.159,8.057s.359,1.8,3.48,1.444l10.681,6.734s.928,8.2-2.039,7.454c-.48-.121-3.83-3.608-6.241-3.365l-14.164-5.533s-3.359-1.925-1.559-8.3,7.753-21.144,7.753-21.144l9.408,5.273Z",
    transform: "translate(-844.725 -371.898)",
    opacity: 0.05
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2045",
    "data-name": "Path 2045",
    d: "M792.978,450.526c-.719,4.57,3.359,4.93,3.359,4.93s15.878,2.341,18.038,1.86,7.526-1.139,7.526-1.139c3.721-2.285.719-7.936.719-7.936s-7.682-.239-9.482-.59-10.92-.85-10.92-.85.719-4.449,5.521-15.75c3.262-7.676.884-12.193-.993-14.3A7.907,7.907,0,0,0,805.1,415.3l-14.762.72a19.17,19.17,0,0,1-.083,2.235,23.839,23.839,0,0,1-1.959,7.381c.84,0,6.241,5.051,6.241,5.051S793.7,445.959,792.978,450.526Z",
    transform: "translate(-774.65 -351.192)",
    fill: "#6639b7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2046",
    "data-name": "Path 2046",
    d: "M819.5,448.744s-7.682-.239-9.482-.59-10.92-.841-10.92-.841.719-4.449,5.522-15.75c3.262-7.676.884-12.193-.993-14.3a7.91,7.91,0,0,0-1.647-1.452l-13.678.667v-.428l14.762-.72a7.92,7.92,0,0,1,1.648,1.452c1.868,2.108,4.254,6.622.993,14.3-4.815,11.293-5.528,15.741-5.528,15.741s9.134.481,10.92.841,9.482.59,9.482.59,3,5.654-.719,7.947c0,0-.112-.053-.295-.13C822.036,453.523,819.5,448.744,819.5,448.744Z",
    transform: "translate(-772.606 -351.213)",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_775",
    "data-name": "Rectangle 775",
    width: 7.44,
    height: 18.877,
    transform: "translate(24.932 19.975)",
    fill: "#7e5068"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_776",
    "data-name": "Rectangle 776",
    width: 7.44,
    height: 18.877,
    transform: "translate(19.893 19.975)",
    fill: "#f5b65f",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2047",
    "data-name": "Path 2047",
    d: "M876.281,248.811c-.256.071-.545.08-.719.434a2.657,2.657,0,0,0-.174.886l-.468,5.834a3.254,3.254,0,0,1-.218,1.116c-.2.4-.525.443-.781.7a3.865,3.865,0,0,0-.525,2.849,18.732,18.732,0,0,0,.778,2.893,27.231,27.231,0,0,0,1.229,4.03c.563,1.145,1.585,1.771,2.245.809s.571-2.9.7-4.5c.206-2.657,1.241-4.948,1.311-7.623a30.633,30.633,0,0,0-.884-6.235c-.259-1.408-.274-3.118-.651-4.384C877.8,247.126,877.2,248.557,876.281,248.811Z",
    transform: "translate(-855.605 -231.605)",
    fill: "#965d7b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2048",
    "data-name": "Path 2048",
    d: "M876.281,248.811c-.256.071-.545.08-.719.434a2.657,2.657,0,0,0-.174.886l-.468,5.834a3.254,3.254,0,0,1-.218,1.116c-.2.4-.525.443-.781.7a3.865,3.865,0,0,0-.525,2.849,18.732,18.732,0,0,0,.778,2.893,27.231,27.231,0,0,0,1.229,4.03c.563,1.145,1.585,1.771,2.245.809s.571-2.9.7-4.5c.206-2.657,1.241-4.948,1.311-7.623a30.633,30.633,0,0,0-.884-6.235c-.259-1.408-.274-3.118-.651-4.384C877.8,247.126,877.2,248.557,876.281,248.811Z",
    transform: "translate(-855.605 -231.605)",
    fill: "#965d7b",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2070",
    "data-name": "Path 2070",
    d: "M-1009.7,4577.251l-10.24,22.85-5.556-5.184,12.858-19.881Z",
    transform: "translate(1064.903 -4566.268)",
    fill: "#fbbebe"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2049",
    "data-name": "Path 2049",
    d: "M750.058,207.062l2.879,2.406s.342-.4.852-1.051c2-2.56,6.6-8.981,3.35-10.129s-5.819,5.113-6.727,7.7C750.182,206.643,750.058,207.062,750.058,207.062Z",
    transform: "translate(-697.885 -198.149)",
    fill: "#fbbebe"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2050",
    "data-name": "Path 2050",
    d: "M935.945,206.393c1.2,1.8,2.879,0,2.879,0s.215-.322.518-.841c.987-1.674,2.923-5.385,1.641-6.855-1.473-1.68-5.124,4.053-5.236,6.743A1.6,1.6,0,0,0,935.945,206.393Z",
    transform: "translate(-935.737 -198.322)",
    fill: "#fbbebe"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2051",
    "data-name": "Path 2051",
    d: "M869.54,286.607s-2.4,7.7-1.68,9.979-5.162,4.939-5.162,4.939h-6.722s-2.4-4.93-1.8-6.374,5.76-2.524,5.76-2.524,3,0,2.879-8.057Z",
    transform: "translate(-839.808 -259.056)",
    fill: "#f5bebe"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2052",
    "data-name": "Path 2052",
    d: "M766.071,226.378l2.878,2.406a4.481,4.481,0,0,0,.449-.558c-1.046-.186-2.462-1.593-3.172-2.307C766,226.574,766.071,226.378,766.071,226.378Z",
    transform: "translate(-713.897 -217.465)",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2053",
    "data-name": "Path 2053",
    d: "M942.957,223.192c1.2,1.8,2.879,0,2.879,0s.215-.322.519-.841l-.038-.121c-.778.558-3.2.083-3.557,0A1.6,1.6,0,0,0,942.957,223.192Z",
    transform: "translate(-942.75 -215.12)",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2061",
    "data-name": "Path 2061",
    d: "M877.7,314.822l-5.851,6.345.487-6.919.328-2.253h.493l-.3,5.348,6.192-4.594C879.04,312.785,878.026,315,877.7,314.822Z",
    transform: "translate(-851.467 -279.02)",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2054",
    "data-name": "Path 2054",
    d: "M846,418.238c3.713,1.7,15.776-1.325,16.5-1.506a7.914,7.914,0,0,0-1.647-1.453l-14.762.72A19.143,19.143,0,0,1,846,418.238Z",
    transform: "translate(-830.388 -351.177)",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2073",
    "data-name": "Path 2073",
    d: "M-938.478,4571.865l-3.184-.508,2.32,13.368a3.646,3.646,0,0,0,.58,1.565c.439.5,5.648,9.3,5.648,9.3l3.492-4.469-3.929-5.313a4.14,4.14,0,0,1-1.046-1.8C-934.762,4583.084-938.478,4571.865-938.478,4571.865Z",
    transform: "translate(941.663 -4563.807)",
    fill: "#fbbebe"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2055",
    "data-name": "Path 2055",
    d: "M806.089,267.777s2.879.962,6.96-2.766a1.875,1.875,0,0,0,2.625-1.325l.617-1.243s6.763,5.106,7.965,4.625l-2.771,1.545a24.408,24.408,0,0,1-3.168,2.261s-4.8,3.322-4.916,5.846-1.364,11.3-1.364,11.3.444,8.738,2.966,10.663c0,0-18.991,3.618-21.991,1.211,0,0,1.087-3.826-.644-10.5,0,0-2.411-9.32-1.637-14.481a8.4,8.4,0,0,0-1.222-5.095,20.49,20.49,0,0,0-3.127-4.126s-1.7-.1-1.7-1.664c0,0-1.11,1.182-.642-1.584,0,0,3.345-2.634,4.185-3.224a3.33,3.33,0,0,1,2.5,1.892c.834,1.618,1.293,3.474,3.589,4.033,4.449,1.083,5.159,1.562,5.159,1.562l-.881,6.629Z",
    transform: "translate(-777.919 -233.613)",
    fill: "#6639b7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2056",
    "data-name": "Path 2056",
    d: "M854.49,289.586a22.969,22.969,0,0,0,.174-3.416l6.721,2.043a9.119,9.119,0,0,0-.421,1.382c-.769.34-1.806,1.143-2.7,1.143a6.112,6.112,0,0,1-3.775-1.151Z",
    transform: "translate(-831.774 -260.184)",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_580",
    "data-name": "Ellipse 580",
    cx: 6.241,
    cy: 6.253,
    rx: 6.241,
    ry: 6.253,
    transform: "translate(20.371 17.69)",
    fill: "#f5bebe"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2057",
    "data-name": "Path 2057",
    d: "M839.449,246.418c1.373.106,2.905,1.057,2.828,2.436a9.26,9.26,0,0,1-.787,2.126c-.545,1.757.669,3.519,1.735,5.019s2.063,3.487,1.149,5.075a12.491,12.491,0,0,1-.843,1.1c-1.129,1.527-1.114,3.587-1.615,5.42a9.49,9.49,0,0,1-11.15,6.79,5.952,5.952,0,0,0,1.253-4.021c-.068-1.051-.407-2.149,0-3.12.524-1.249,2.062-1.742,2.855-2.834a4.538,4.538,0,0,0,.356-3.909c-.383-1.3-1.046-2.509-1.364-3.838a11.63,11.63,0,0,0-.295-1.148,5.124,5.124,0,0,0-3.83-2.884c-1.621-.393-3.324-.416-4.906-.933s-3.12-1.727-3.3-3.389c1.332.534,2.567-.859,3.852-1.5,2.115-1.051,4.529-.062,6.709.18C834.578,247.266,836.935,246.235,839.449,246.418Z",
    transform: "translate(-805.411 -232.108)",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2058",
    "data-name": "Path 2058",
    d: "M839.038,245.608c1.373.106,2.905,1.057,2.829,2.436a9.277,9.277,0,0,1-.787,2.126c-.545,1.757.669,3.519,1.736,5.019s2.063,3.486,1.149,5.075a12.539,12.539,0,0,1-.843,1.1c-1.129,1.526-1.114,3.587-1.614,5.42a9.49,9.49,0,0,1-11.15,6.79,5.954,5.954,0,0,0,1.253-4.021c-.068-1.051-.407-2.149,0-3.12.524-1.249,2.062-1.742,2.855-2.834a4.536,4.536,0,0,0,.357-3.909c-.383-1.3-1.046-2.509-1.364-3.838a11.562,11.562,0,0,0-.295-1.148,5.124,5.124,0,0,0-3.83-2.884c-1.621-.393-3.324-.416-4.906-.933s-3.121-1.727-3.3-3.389c1.332.534,2.566-.859,3.851-1.5,2.116-1.051,4.529-.062,6.71.18C834.161,246.453,836.51,245.41,839.038,245.608Z",
    transform: "translate(-804.88 -231.538)",
    fill: "#965d7b"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_752",
    "data-name": "Group 752",
    transform: "translate(18.329 35.172)",
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2063",
    "data-name": "Path 2063",
    d: "M804.165,312.619c-2.519-1.925-3.066-10.77-3.066-10.77s.841-8.831.962-11.355,3.217-4.279,3.217-4.279c1.32-.72,2.7-1.647,2.7-1.647s3.952-1.365,5.151-1.846l-3.951,2.353a15.34,15.34,0,0,1-1.882,1.14s-3.679,1.755-3.8,4.279-1.441,11.355-1.441,11.355.4,8.845,2.918,10.77c0,0-13.463,2.226-18.638,2.025C791.527,314.461,804.165,312.619,804.165,312.619Z",
    transform: "translate(-786.341 -282.722)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_2071",
    "data-name": "Path 2071",
    d: "M5.383.067,4.049,0,0,15.733s4.363-1.108,6.242-.006A16.219,16.219,0,0,0,10.49,17.32l-.3-13.437Z",
    transform: "matrix(-0.602, 0.799, -0.799, -0.602, 23.092, 32.286)",
    fill: "#6639b7"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_758",
    "data-name": "Group 758",
    transform: "translate(3.789 30.171)",
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2065",
    "data-name": "Path 2065",
    d: "M908.623,267.534s7.564,4.693,8.8,6.088.715,3.942.715,3.942c-.572-.939-.226-2.473-1.015-3.363-1.238-1.395-8.5-6.212-8.5-6.212Z",
    transform: "translate(-908.623 -267.534)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_2092",
    "data-name": "Path 2092",
    d: "M30.191,0C13.517,0,0,1.752,0,3.912S13.517,7.825,30.191,7.825,60.382,6.073,60.382,3.912,46.865,0,30.191,0Z",
    transform: "translate(0 146.175)",
    fill: "#6639b7",
    opacity: 0.1
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgJumpingWomanIcon);
export default __webpack_public_path__ + "static/media/jumping_woman_icon.f708c826dd80ee1cb8df0ed9e2d04c1c.svg";
export { ForwardRef as ReactComponent };